"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _formatDate = require("../../lib/format-date");

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _modal = _interopRequireDefault(require("./../modal"));

var _formInputs = require("./../form-inputs");

var _loader = _interopRequireDefault(require("../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var groupMap = {
  'Administrator': 'admins',
  'Kantonsverantwortliche': 'cantonResponsibleUser',
  'Projektverantwortliche': 'projectResponsibleUser'
};

var DashboardProjectList = /*#__PURE__*/function (_React$Component) {
  _inherits(DashboardProjectList, _React$Component);

  function DashboardProjectList(props) {
    var _this;

    _classCallCheck(this, DashboardProjectList);

    _this = _possibleConstructorReturn(this, (DashboardProjectList.__proto__ || Object.getPrototypeOf(DashboardProjectList)).call(this, props));
    _this.state = {
      list: [],
      users: [],
      isLoading: false,
      isUserLoading: false,
      assignModalOpen: false
    };
    _this.loadProjects = _this.loadProjects.bind(_assertThisInitialized(_this));
    _this.columnDateCreate = _this.columnDateCreate.bind(_assertThisInitialized(_this));
    _this.columnCanton = _this.columnCanton.bind(_assertThisInitialized(_this));
    _this.columnUser = _this.columnUser.bind(_assertThisInitialized(_this));
    _this.columnEdit = _this.columnEdit.bind(_assertThisInitialized(_this));
    _this.closeAssingModal = _this.closeAssingModal.bind(_assertThisInitialized(_this));
    _this.assignUser = _this.assignUser.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DashboardProjectList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this.loadProjects();
      if (this.props.enableAssignToUser) this.loadUsers();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$state = this.state,
          list = _this$state.list,
          isLoading = _this$state.isLoading,
          isUserLoading = _this$state.isUserLoading;
      var loading = isLoading || isUserLoading;
      var columns = [{
        key: 'edit',
        title: '',
        render: this.columnEdit
      }, {
        key: 'username',
        title: t('username'),
        prop: 'username'
      }, {
        key: 'last_name',
        title: t('last name'),
        prop: 'last_name'
      }, {
        key: 'date',
        title: t('register date'),
        render: this.columnDateCreate,
        prop: 'date_create'
      }, {
        title: t('canton'),
        render: this.columnCanton,
        prop: 'canton_name',
        defaultContent: '-'
      }, {
        title: t('city'),
        prop: 'city'
      }, {
        key: 'project',
        title: t('project'),
        render: function render(val, row) {
          return t(row.project);
        },
        prop: 'project'
      }, {
        key: 'assigned',
        title: t('assigned'),
        prop: 'assigned_to',
        render: this.columnUser
      }];

      if (!this.props.enableAssignToUser) {
        columns = columns.filter(function (column) {
          return column.key !== 'assigned';
        });
      }

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.props.anchor || "".concat(this.props.projectKey, "-list")
      }, this.props.label ? this.props.label : t("open list ".concat(this.props.projectKey))), !loading && /*#__PURE__*/_react.default.createElement(_datalist.default, {
        initialData: list,
        enableSort: true,
        isLoading: loading,
        staticTexts: {
          noData: t('no data'),
          loading: t('loading data')
        },
        columns: columns,
        initialPageLength: 20,
        keys: ['id'],
        showSearch: false
      }), loading && /*#__PURE__*/_react.default.createElement(_loader.default, {
        size: 'medium'
      }), this.props.enableAssignToUser && /*#__PURE__*/_react.default.createElement(_modal.default, {
        backgroundClickClose: true,
        escClose: true,
        closeHandler: this.closeAssingModal,
        id: "user-assign-modal-".concat(this.props.projectKey),
        isOpen: this.state.assignModalOpen
      }, /*#__PURE__*/_react.default.createElement(_formInputs.Select, {
        allowAll: true,
        all: t('Nicht Zugewiesen'),
        label: t('Benutzer'),
        list: this.state.users.map(function (user) {
          return {
            id: user.id,
            name: "".concat(user.first_name, " ").concat(user.last_name, " (").concat(user.email, ")")
          };
        }),
        name: 'user',
        t: this.props.t,
        value: this.state.assignModalOpen.user,
        onChange: this.assignUser
      }), /*#__PURE__*/_react.default.createElement("button", {
        type: 'button',
        className: 'btn',
        onClick: this.closeAssingModal
      }, t('close'))));
    }
    /**
     *
     */

  }, {
    key: "loadProjects",
    value: function loadProjects() {
      var _this2 = this;

      this.setState(function (prev) {
        prev.isLoading = true;
        return prev;
      }, function () {
        fetch(_this2.props.loadProjectUrl, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (response) {
          if (!_this2._isMounted) {
            return;
          }

          _this2.setState(function (prev) {
            prev.list = response;
            prev.isLoading = false;
            return prev;
          });
        }).catch(function (err) {
          void 0;

          if (!_this2._isMounted) {
            return;
          }

          _this2.setState(function (prev) {
            prev.isLoading = false;
            return prev;
          });
        });
      });
    }
    /**
     *
     */

  }, {
    key: "loadUsers",
    value: function loadUsers() {
      var _this3 = this;

      this.setState(function (prev) {
        prev.isUserLoading = true;
        return prev;
      }, function () {
        fetch("/api/".concat(_this3.props.i18n.language, "/backendusers"), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (persons) {
          if (!_this3._isMounted) {
            return;
          }

          var map = persons.reduce(function (result, person) {
            var key = groupMap[person.group.name];
            result[key] = result[key] || [];
            result[key].push(person);
            return result;
          }, {});

          _this3.setState(function (prev) {
            prev.users = map.admins;
            prev.isUserLoading = false;
            return prev;
          });
        }).catch(function (err) {
          void 0;

          if (!_this3._isMounted) {
            return;
          }

          _this3.setState(function (prev) {
            prev.isUserLoading = false;
            return prev;
          });
        });
      });
    }
    /**
     *
     * @param val
     * @param row
     * @returns {string}
     */

  }, {
    key: "columnDateCreate",
    value: function columnDateCreate(val, row) {
      return (0, _formatDate.formatDate)(row.date_create);
    }
    /**
     *
     * @param val
     * @param row
     * @returns {string}
     */

  }, {
    key: "columnCanton",
    value: function columnCanton(val, row) {
      // eslint-disable-next-line camelcase
      return row.canton_name ? row.canton_name : '-';
    }
    /**
     *
     * @param val
     * @param row
     * @returns {*}
     */

  }, {
    key: "columnUser",
    value: function columnUser(val, row) {
      var _this4 = this;

      var t = this.props.t;

      var openModalHandler = function openModalHandler() {
        _this4.setState(function (prev) {
          prev.assignModalOpen = {
            projectKey: row.project,
            farmId: row.farm_id,
            user: row.assigned_to
          };
          return prev;
        });
      };

      var userId = parseInt(row.assigned_to),
          noUser = /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link assigned",
        href: '',
        title: t('Zuweisen'),
        onClick: function onClick(e) {
          e.preventDefault();
          openModalHandler();
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-edit"
      }));

      if (userId === 0) return noUser;
      var user = this.state.users.find(function (user) {
        return parseInt(user.id) === userId;
      });
      if (!user) return noUser;
      return /*#__PURE__*/_react.default.createElement("a", {
        href: '',
        title: t('Zuweisen'),
        onClick: function onClick(e) {
          e.preventDefault();
          openModalHandler();
        }
      }, "".concat(user.last_name));
    }
    /**
     *
     * @param val
     * @param row
     * @returns {*}
     */

  }, {
    key: "columnEdit",
    value: function columnEdit(val, row) {
      var t = this.props.t,
          href = "/".concat(row.project, "-release/").concat(row.farm_id);
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        href: href,
        title: t('Edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
    /**
     *
     */

  }, {
    key: "closeAssingModal",
    value: function closeAssingModal() {
      this.setState(function (prev) {
        prev.assignModalOpen = false;
        return prev;
      });
    }
    /**
     *
     * @param e
     */

  }, {
    key: "assignUser",
    value: function assignUser(e) {
      var _this5 = this;

      var userId = e.target.value; // /:lang/administration/farm/:farmId/project/:key/assign

      fetch("/api/".concat(this.props.i18n.language, "/administration") + "/farm/".concat(this.state.assignModalOpen.farmId, "/project/").concat(this.state.assignModalOpen.projectKey, "/assign"), {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          userId: userId
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function () {
        if (!_this5._isMounted) {
          return;
        }

        _this5.setState(function (prev) {
          if (!prev.assignModalOpen) return prev;
          prev.assignModalOpen.user = userId;
          return prev;
        }, _this5.loadProjects);
      }).catch(function (err) {
        void 0;

        if (!_this5._isMounted) {
          return;
        }

        _this5.setState(function (prev) {
          if (!prev.assignModalOpen) return prev;
          prev.assignModalOpen.user = '';
          return prev;
        });
      });
    }
  }]);

  return DashboardProjectList;
}(_react.default.Component);

DashboardProjectList.propTypes = {
  t: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  loadProjectUrl: _propTypes.default.string.isRequired,
  projectKey: _propTypes.default.string.isRequired,
  enableAssignToUser: _propTypes.default.bool,
  label: _propTypes.default.string,
  anchor: _propTypes.default.string
};
var _default = DashboardProjectList;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/dashboard-project-list/index.js
// module id = 267
// module chunks = 0